import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom'
import * as contentCardConstants from "../../../../shared/constants/contentCards";
import windowNames from '../../../../shared/constants/windowNames';
import { routeCountryPath } from '../../../../shared/utilities/common';
import { trackContentCardClick } from "../../../../shared/utilities/brazeTracking";
import * as brazeRepo from "../../../../shared/repos/marketing/braze";
import amplitudeAnalytics from '../../../../shared/utilities/amplitude';
import { resolveAmplitudePageName } from '../../../../shared/utilities/amplitudePageMapping';

export class ContentCardBase extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.categoryElement = React.createRef();
  }

  getAmplitudePageName = () => {
    const { location } = this.props;
    const pathname =
      location?.pathname
      || (typeof window !== 'undefined' ? window.location.pathname : '');
    return resolveAmplitudePageName(pathname) || 'Other';
  }

  getCardSort = (cardData) =>
    cardData?.extras?.sort
    || cardData?.extras?.cardSort
    || cardData?.cardSort
    || ''

  trackAmplitudePageContentEvents = (cardData) => {
    const pageName = this.getAmplitudePageName();
    /* Click Page Content: section only — Braze card ids are not useful as Content Element. */
    const contentSection = 'Hero Content Card';
    amplitudeAnalytics.trackClickPageContent({
      pageName,
      contentSection,
    });

    amplitudeAnalytics.trackClickedPromotionElement({
      pageName,
      cardSort: this.getCardSort(cardData),
    });
  }

  recordClick = (cardData) => {
    const { contentCardSession } = this.props;

    if (!cardData) {
      return;
    }

    const { extras = {} } = cardData;
    const { logEventName } = extras;

    this.trackAmplitudePageContentEvents(cardData);
    trackContentCardClick(cardData);
    contentCardSession(true);

    if (logEventName !== undefined) {
      brazeRepo.logEvent(logEventName, {});
    }
  }

  navigateToCard = (cardData) => {
    const { history } = this.props;
    const url = cardData?.url || cardData?.u;

    if (!url) {
      return;
    }

    const isExternal = url.startsWith(contentCardConstants.EXTERNAL_URL_PREFIX);

    if (isExternal) {
      window.open(url, windowNames.CONTENT_CARD_SESSION);
      return;
    }

    const hasDeepLink = url.match('#');
    if (hasDeepLink !== null) {
      const redirectLink = url.replace('#', "");
      this.handleDeepLink(redirectLink);
    } else {
      const finalUrl = routeCountryPath(url);
      history.push(finalUrl);
    }
  }

  handleDeferredClick = (cardData) => {
    this.navigateToCard(cardData);
  }

  handleClick = (cardData) => {
    if (!cardData) {
      return;
    }

    this.recordClick(cardData);
    this.navigateToCard(cardData);
  }

    render() {
      return null;
    }
}

ContentCardBase.propTypes = {
  cardData: PropTypes.shape(
    {
      id: PropTypes.string,
      imageUrl: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      url: PropTypes.string,
      extras: PropTypes.shape(
        {
          template: PropTypes.string,
          isLimited: PropTypes.string,
          isCookieLab: PropTypes.string,
          leftImage: PropTypes.string,
          rightImage: PropTypes.string,
          actionButtonColorText: PropTypes.string,
          actionButtonFill: PropTypes.string,
          actionButtonText: PropTypes.string,
          logEventName: PropTypes.string
        }
      )
    }
  ).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  contentCardSession: PropTypes.func.isRequired
}

ContentCardBase.defaultProps = {
  location: null,
}

export default withRouter(ContentCardBase);
